import { ErrorPaymentData } from '@p2p/entities/payment';
import { Component, ReactNode } from 'react';

import { ServerErrorPage } from '../Errors/ServerErrorPage';

export class MatchingPaymentErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  componentDidCatch(error: unknown) {
    if (error instanceof ErrorPaymentData) {
      this.setState({ hasError: true });
    }

    if (import.meta.env.DEV) {
      console.error(error);
    }
  }

  render() {
    if (this.state.hasError) {
      return <ServerErrorPage />;
    }
    return this.props.children;
  }
}
